import { getOr } from 'lodash/fp';
import { useCallback, useMemo } from 'react';

export const useSDLTableData = ({
  columnHeadersAccessControl,
  columnHeadersCameras,
  columnHeadersIntercoms,
  columnHeadersStratocast,
  columnHeadersSaas,
  filterMenuAccessControl,
  filterMenuCameras,
  filterMenuIntercoms,
  filterMenuStratocast,
  filterMenuSaas,
}: any) => {
  const SDLHeaders = useMemo(
    () => ({
      camera: columnHeadersCameras,
      intercom: columnHeadersIntercoms,
      'access-control': columnHeadersAccessControl,
      stratocast: columnHeadersStratocast,
      saas: columnHeadersSaas,
    }),
    [
      columnHeadersAccessControl,
      columnHeadersCameras,
      columnHeadersIntercoms,
      columnHeadersStratocast,
      columnHeadersSaas,
    ],
  );

  const SDLDeaderFiltersLabels = useMemo(
    () => ({
      camera: filterMenuCameras,
      intercom: filterMenuIntercoms,
      'access-control': filterMenuAccessControl,
      stratocast: filterMenuStratocast,
      saas: filterMenuSaas,
    }),
    [
      filterMenuAccessControl,
      filterMenuCameras,
      filterMenuIntercoms,
      filterMenuStratocast,
      filterMenuSaas,
    ],
  );

  const getContentCategoryHeaders = useCallback(
    (categoryType: string) => getOr({}, categoryType, SDLHeaders),
    [SDLHeaders],
  );

  const getContentCategoryFiltersLabels = useCallback(
    (categoryType: string) => getOr({}, categoryType, SDLDeaderFiltersLabels),
    [SDLDeaderFiltersLabels],
  );

  return { getContentCategoryHeaders, getContentCategoryFiltersLabels };
};
